import type {Expand} from '../types';

export const subtenantExpandCommon: Expand = {
  subtenant: ['tenant_id'],
};
